import React from 'react';

const TermsAndConditionsMeriastro = () => {
    return (
        <div className="max-w-screen-md mx-auto p-8 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-300">
            <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

            <p className="text-lg mb-4">
                These Terms and Conditions ("Terms") govern your access to and use of the Meriastro mobile application and related services (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms. If you do not agree with any part of these Terms, please refrain from using the Service.
            </p>

            <h2 className="text-2xl font-semibold mb-4">1. Use of the Service</h2>
            <p className="text-lg mb-4">
                The Meriastro app provides astrology-based features including horoscopes, tarot cards, sky events, and interactive experiences. You may use the Service only in compliance with these Terms and all applicable laws. Misuse or unauthorized use may result in termination of your access.
            </p>

            <h2 className="text-2xl font-semibold mb-4">2. Account Registration and Security</h2>
            <p className="text-lg mb-4">
                To access personalized features, you may need to create an account. You agree to provide accurate and complete information. You are responsible for safeguarding your credentials and for all activity under your account. Notify us of any unauthorized use immediately.
            </p>

            <h2 className="text-2xl font-semibold mb-4">3. Intellectual Property Rights</h2>
            <p className="text-lg mb-4">
                Meriastro retains all rights to the content and services offered. You may not reproduce, modify, or distribute any part of the Service without written permission. Unauthorized use may violate copyright or trademark laws.
            </p>

            <h2 className="text-2xl font-semibold mb-4">4. User-Generated Content</h2>
            <p className="text-lg mb-4">
                You may submit questions or feedback within the app. By doing so, you grant Meriastro a non-exclusive, worldwide, royalty-free license to use, reproduce, and display such content for the purpose of improving the Service.
            </p>

            <h2 className="text-2xl font-semibold mb-4">5. Privacy and Data Collection</h2>
            <p className="text-lg mb-4">
                We collect and process personal data in line with our Privacy Policy. This includes your email, password, birth date, username, and device ID. Use of the app constitutes your consent to such processing.
            </p>

            <h2 className="text-2xl font-semibold mb-4">6. Termination</h2>
            <p className="text-lg mb-4">
                We may suspend or terminate your access to the Service at any time, with or without cause. You may terminate your account by contacting us at: <a href="mailto:samedakgul99@gmail.com" className="text-blue-500">samedakgul99@gmail.com</a>.
            </p>

            <h2 className="text-2xl font-semibold mb-4">7. Modifications to the Terms</h2>
            <p className="text-lg mb-4">
                We reserve the right to update these Terms. Changes will be communicated via the app or email. Continued use of the Service after changes are made constitutes acceptance of the new Terms.
            </p>

            <h2 className="text-2xl font-semibold mb-4">8. Disclaimers</h2>
            <p className="text-lg mb-4">
                The Service is provided "as is" without warranties of any kind. We do not guarantee the accuracy of astrological content or uninterrupted availability of the app. Use it at your own discretion.
            </p>

            <h2 className="text-2xl font-semibold mb-4">9. Limitation of Liability</h2>
            <p className="text-lg mb-4">
                To the fullest extent permitted by law, Meriastro shall not be liable for indirect, incidental, or consequential damages arising from your use of the Service.
            </p>

            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
            <p className="text-lg mb-4">
                For questions or support, contact us at: <a href="mailto:samedakgul99@gmail.com" className="text-blue-500">samedakgul99@gmail.com</a>.
            </p>
        </div>
    );
};

export default TermsAndConditionsMeriastro;